export const TIPS_CONTAINER_ID = "tips-container";
export const FILTER_ID_CONTAINER = "filters-container";
export const CARD_ORIENTATION_ID_CONTAINER = "card-orientation-container";
export const SORT_ID_CONTAINER = "sort-container";
export const CTA_TIPS_CONTAINER = "cta-tips-container";
export const RESULT_COUNT_CONTAINER = "result-count-container";
export const RESULTS_CONTAINER = "results-container";
export const HERO_MAIN_ID_CONTAINER = "hero-main-container";
export const HERO_ID_CONTAINER = "hero-container";
export const HERO_CTA_ID_CONTAINER = "hero-cta-button-";
export const HERO_BRAND_MOBILE_ID_CONTAINER = "hero-brand-mobile-container";
export const HERO_BRAND_ID_CONTAINER = "hero-brand-container";
export const HERO_SUBTITLE_ID_CONTAINER = "hero-subtitle-container";
export const HERO_TITLE_ID_CONTAINER = "hero-title-container";
export const HERO_MAIN_ILLUSTRATION_ID_CONTAINER = "hero-main-illustration-container";
export const HERO_FILTER_ID_CONTAINER = "hero-filter-container";
export const PRODUCT_DETAIL_CONTENT_ID_CONTAINER = "product-detail-content-container";
export const PRODUCT_DETAIL_HEADER_ID_CONTAINER = "product-detail-header-container";
export const TIP_MAIN_IMAGE_ID_CONTAINER = "tip-main-image-container";
export const TIP_CONTENT_ID_CONTAINER = "tip-content-container";
export const TIP_TITLE_ID_CONTAINER = "tip-title-container";
export const TIP_BANNER_ACTION_ID_CONTAINER = "tip-banner-action-container";
export const TIP_AUTHOR_ID_CONTAINER = "tip-author-container";
export const TIP_RELATED_PRODUCTS_ID_CONTAINER = "tip-related-products-container";
export const TIP_RELATED_TIPS_ID_CONTAINER = "tip-related-tips-container";
export const ENTITY_CODE_FREE_INSTALLMENT_RIBBON = "card-flag";
